<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <PageHeader :title="title" :items="items"/>
        <b-card>
          <form action="">
            <div class="form-row">
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label class="col-form-label col-form-label-sm" for="district_id">District</label>
                <select v-model="search_data.district_id" class="form-control form-control-sm" name="district_id" id="district_id">
                  <option selected :value="''">Select a District</option>
                  <option v-for="(district, index) in districts" :key="index" :value="district.id">{{district.id }} : {{ district.district_desc }}</option>
                </select>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label class="col-form-label col-form-label-sm" for="upazila_id">Upazila</label>
                <select v-model="search_data.upazila_id" class="form-control form-control-sm" name="upazila_id" id="upazila_id">
                  <option selected :value="''">Select a Upazila</option>
                  <option v-for="(upazila, index) in upazilas" :key="index" :value="upazila.id">{{upazila.id }} : {{ upazila.upazila_desc }}</option>
                </select>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label class="col-form-label col-form-label-sm" for="union_id">Union</label>
                <select v-model="search_data.union_id" class="form-control form-control-sm" name="union_id" id="union_id">
                  <option selected :value="''">Select a Union</option>
                  <option v-for="(union, index) in unions" :key="index" :value="union.id">{{union.id }} : {{ union.union_desc }}</option>
                </select>
              </div>
            </div>
            <div class="form-row mt-2">
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label class="col-form-label col-form-label-sm" for="mouza_id">Mouza</label>
                <select v-model="search_data.mouza_id" class="form-control form-control-sm" name="mouza_id" id="mouza_id">
                  <option selected :value="''">Select a Mouza</option>
                  <option v-for="(mouza, index) in mouzas" :key="index" :value="mouza.id">{{mouza.id }} : {{ mouza.mouza_desc }}</option>
                </select>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                  <label for="plot_no">Plot No</label>
                  <input v-model="search_data.plot_no" type="text" class="form-control form-control-sm" placeholder="Search by plot no" id="plot_no"/>
                </div>
            </div>
              <button class="btn btn-success btn-sm mt-2"  @click.prevent="search()">Search</button>
          </form>
        </b-card>

        <b-card>
          <div class="row mb-2" v-if="land_plots">
            <div class="col-sm-4">
              <span class="badge badge-success">Total Search Data Found: {{ land_plots.total }}</span>
            </div>
          </div>
          <div class="table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
              <tr>
                <th>Sl</th>
                <th>Mouza</th>
                <th>Plot No</th>
                <th>Total CCL (BDT.)</th>
                <th>Total Land to be Acquired (Decimal)</th>
                <th>Paid Land (Decimal)</th>
                <th>Payment Done, AGL (BDT.)</th>
                <th>Payment in Progress (Decimal)</th>
                <th>Payment In Progress, AGL (BDT.)</th>
                <th>Remaining Land</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(land_plot, index) in land_plots.data" :key="index">
                <td>{{index + land_plots.from}}</td>
                <td>{{land_plot.mouza.mouza_desc}}</td>
                <td>{{land_plot.plot_no}}</td>
                <td></td>
                <td>{{land_plot.plot_total_land}}</td>
                <td>{{land_plot.paidLandDecimal != 0 ? land_plot.paidLandDecimal : ''}}</td>
                <td>{{land_plot.paymentDoneAgl != 0 ? land_plot.paymentDoneAgl : ''}}</td>
                <td>{{land_plot.paymentInProgressDecimal != 0 ? land_plot.paymentInProgressDecimal : ''}}</td>
                <td>{{land_plot.paymentInProgressAgl != 0 ? land_plot.paymentInProgressAgl : ''}}</td>
                <td>{{getRemainingLand(land_plot.plot_total_land, land_plot.paidLandDecimal)}}</td>
              </tr>
              </tbody>
            </table>
            <h5 v-if="!flag  || land_plots.total == 0" class="text-center text-secondary">
              No Data Found
            </h5>
            <div class="float-right">
              <pagination :data="land_plots" :limit="2" @pagination-change-page="getResults"></pagination>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";

export default {
  page: {
    title: "List of Plot Land",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Search of Plot Land",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Plot Land",
          active: true
        }
      ],
      land_plots: {},
      search_data: {
        plot_no:'',
        mouza_id: '',
        upazila_id: '',
        district_id: '',
        union_id: ''
      },
      districts: [],
      all_upazilas: [],
      all_unions: [],
      all_mouzas: [],
      flag: false
    };
  },

  mounted() {
    this.getCodes();
  },
  methods: {
    getCodes() {
      http.get("api/land/plot/codes").then(response => {
        if (!response.error) {
          let data = response.data;
          this.districts = data.districts;
          this.all_upazilas = data.upazilas;
          this.all_unions = data.unions;
          this.all_mouzas = data.mouzas;
        }
      });
    },
    search() {
      http.post("api/land/plot/view", this.search_data).then(response => {
        if (!response.error) {
          this.flag = true;
          this.land_plots = response.data.land_mouzas;
          
          console.log(response.data)
        }
      });
    },
    getResults(page = 1) {
      http.post('api/land/plot/view?page=' + page, this.search_data)
          .then(response => {
            this.flag = true;
            this.land_plots = response.data.land_mouzas;
          });
    },
    getRemainingLand(totalLand, paidLand){
      return (totalLand - paidLand).toFixed(4);
    }
  },
  computed: {
    upazilas() {
      const district_id = this.search_data.district_id
      return (district_id)
          ? this.all_upazilas.filter(x => x.district_id === district_id)
          : null
    },
    unions() {
      const upazila_id = this.search_data.upazila_id
      return (upazila_id)
          ? this.all_unions.filter(x => x.upazila_id === upazila_id)
          : null
    },
    mouzas() {
      const union_id  = this.search_data.union_id
      return (union_id )
          ? this.all_mouzas.filter(x => x.union_id === union_id )
          : null
    },
  },
};
</script>
<style src="vue-select/dist/vue-select.css"></style>
